import Component from '@glimmer/component';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("{{#unless @custom_field.organization_custom_field.disabled}}\n  <BbField\n    @classLabel={{this.classLabel}}\n    @classText={{this.classText}}\n    @label={{@custom_field.organization_custom_field.name}}\n  >\n    <CustomFieldValue @custom_field={{@custom_field}} @me={{@me}} />\n  </BbField>\n{{/unless}}");

/**
 * MAP (in-file navigation graph — keep in sync with code):
 *   role:      component (label + value layout wrapper around one custom field)
 *   extends:   Component (@glimmer)
 *   template:  view-custom-field.hbs (colocated)
 *   args:      @classLabel, @classText (grid-class overrides, both default here); template
 *              forwards @custom_field/@label/@me to <BbField>/<CustomFieldValue>
 *   uses:      children <BbField>, <CustomFieldValue>
 *   siblings:  custom-field-value (the value renderer this wraps)
 *   tests:     tests/unit/components/view-custom-field-test.js
 */
class ViewCustomFieldComponent extends Component {
  get classLabel() {
    return this.args.classLabel ?? 'small-12 medium-3 cell beebeeLabel';
  }
  get classText() {
    return this.args.classText ?? 'cell small-12 medium-9';
  }
}
setComponentTemplate(TEMPLATE, ViewCustomFieldComponent);

export { ViewCustomFieldComponent as default };
//# sourceMappingURL=view-custom-field.js.map
